import { createClient } from '@supabase/supabase-js';

const FALLBACK_SUPABASE_URL = 'https://nvjojhjdjbpsltgsxgno.supabase.co';
const FALLBACK_SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im52am9qaGpkamJwc2x0Z3N4Z25vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk3NjI0MTQsImV4cCI6MjA4NTMzODQxNH0.dALppPEEcLjiZw1LErzLCPnjrtXxqtZwLwF1e7UXleQ';

const envUrl = import.meta.env.VITE_SUPABASE_URL;
const envKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

const supabaseUrl = envUrl || FALLBACK_SUPABASE_URL;
const supabaseKey = envKey || FALLBACK_SUPABASE_ANON_KEY;

if (!envUrl || !envKey) {
  console.warn('Supabase: variables d’environnement manquantes. Fallback appliqué (URL/clé par défaut).');
}

// Create Supabase client with optimized configuration
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false
  },
  global: {
    headers: {
      'Content-Type': 'application/json'
    }
  }
});

// Test connection with improved error handling and retry logic
const testConnection = async (retries = 3, delay = 1000) => {
  for (let i = 0; i < retries; i++) {
    // Simple health check query that always returns a single row
    const { error } = await supabase
      .from('users')
      .select('count', { head: true })
      .limit(0);

    if (error) {
      console.error(`Connection attempt ${i + 1}/${retries} failed:`, error);
      
      if (i < retries - 1) {
        console.log(`Retrying in ${delay}ms...`);
        await new Promise(resolve => setTimeout(resolve, delay));
        continue;
      }
      
      throw error;
    }

    console.log('Supabase connection established successfully');
    return true;
  }
  return false;
};

// REMOVED: Automatic connection test that was causing refresh loops
// The connection will be tested on first actual use instead

export { testConnection };